<template>
  <div>
    <vue-editor
      v-if="!readOnly"
      v-model="internalValue"
      :editor-toolbar="customToolbar"
      :editorOptions="editorSettings"
    ></vue-editor>
    <div class="rich-content" v-else v-html="value.join(', ')"></div>
  </div>
</template>

<script>
import inputMixin from '@/mixins/inputMixin'
import { VueEditor } from "vue2-editor";
import quill from 'quill'
const Delta = quill.import('delta')

export default {
  name: 'InputFieldType',
  mixins: [inputMixin],
  components: {VueEditor},
  data() {
    return {
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
      ],
      editorSettings: {
        //formats: ["bold", "italic", "underline", { list: "ordered" }, { list: "bullet" }],
        modules: {
          clipboard: {
            matchers: [
              [Node.ELEMENT_NODE, this.customMatcher]
            ]
          }
        }
      }
    }
  },
  methods: {
    customMatcher(node, delta) {
      var plaintext = node.textContent
      if(plaintext){
        return new Delta().insert(plaintext)
      }
      else {
        return delta
      }
    }
  }
}
</script>

<style lang="stylus">
@import "~vue2-editor/dist/vue2-editor.css"
@import "~quill/dist/quill.core.css"

.quillWrapper
  background-color: #fff
  border: 1px solid rgba($heather, 0.5)
  border-radius: 4px
  box-shadow: 5px 5px 20px rgba($lynch, 0.25)

  .ql-toolbar
    border: none !important
    border-bottom: 1px solid rgba($heather, 0.5) !important
    font-family: $base-font-family !important
    padding: 10px !important

    .ql-formats
      margin-bottom: 0 !important

      &:not(:last-child)
        border-right: 1px solid rgba($heather, 0.5)
        padding-right: 15px

      button
        background-color: #fff
        border: none
        box-shadow: none
        min-width: auto

  .ql-container
    border: none !important
    font-family: $base-font-family !important

.rich-content
  p
    margin-top: 0

  ul
    padding-left: 40px

  li
    list-style-type: disc
    // margin-left: 15px
</style>